import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddSubCategoryType } from "./FormAddSubCategoryType";

export const PanelAddSubCategoryType = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Ad Subcategory Type</div>
          </div>
        }
      />
      <PanelBody content={<FormAddSubCategoryType />} />
    </div>
  );
};
